import "./OurStory.module.css";
import Header from "@/reusable_sections/Header";
import TheTorchlighterVision from "./sections/TheTorchlighterVision";
import MeetTheAdvocates from "./sections/MeetTheAdvocates";
import OurCommunityPartners from "./sections/OurCommunityPartners";
import Footer from "@/reusable_sections/Footer";
export default function OurStoryPage() {
  return <div>
      <Header />
      <TheTorchlighterVision />
      <MeetTheAdvocates />
      <OurCommunityPartners />
      <Footer />
    </div>;
}